import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free-brands';

class Home extends Component {
    render() {
        return (
            <div>
                <div className="uk-padding-large uk-padding-remove-horizontal">
                    <div uk-grid="true">
                        <div className="uk-width-1-2@s uk-animation-slide-top-small">
                            <h2 className="uk-text-uppercase uk-text-primary">Design<sup>+</sup> Creative<sup>+</sup> <br/>
                                Develop<sup>+</sup> Debug<sup>+</sup> <br/>
                                Test<sup>+</sup></h2>
                            <p>Hello i am sajid. I have ample experience in WEB Development and Designing. I Worked on various projects using HTML5, CSS3, JavaScript, Drupal, WordPress and Laravel.</p>
                            <button className="uk-button uk-button-secondary uk-margin-small-right">Download CV</button>
                            <NavLink activeClassName="selected" to="/contact" className="uk-button uk-button-primary">Hire Me</NavLink>
                        </div>
                        <div className="uk-visible@s uk-width-1-2@s uk-width-1-2@m uk-width-1-2@l uk-width-1-2@xl uk-animation-slide-top-small">
                            <div uk-grid="true" className="uk-text-center">
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-react" icon={["fab", "react"]}/></div>
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-nodejs" icon={["fab", "node-js"]}/></div>
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-angular" icon={["fab", "angular"]}/></div>
                                <div className="uk-width-1-4 "><FontAwesomeIcon className="fa-5x color-javascript" icon={["fab", "js"]}/></div>
                            </div>
                            <div uk-grid="true" className="uk-text-center">
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-drupal" icon={["fab", "drupal"]}/></div>
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-laravel" icon={["fab", "laravel"]}/></div>
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-php" icon={["fab", "php"]}/></div>
                                <div className="uk-width-1-4"></div>
                            </div>
                            <div uk-grid="true" className="uk-text-center">
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-html" icon={["fab", "html5"]}/></div>
                                <div className="uk-width-1-4"><FontAwesomeIcon className="fa-5x color-css" icon={["fab", "css3"]}/></div>
                                <div className="uk-width-1-4"></div>
                                <div className="uk-width-1-4"></div>
                            </div>
                            <div uk-grid="true" className="uk-text-center">
                                <div className="uk-width-1-4 "><FontAwesomeIcon className="fa-5x color-linux" icon={["fab", "linux"]}/></div>
                                <div className="uk-width-1-4 "></div>
                                <div className="uk-width-1-4 "></div>
                                <div className="uk-width-1-4 "></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// src/components/Home.js